module.exports = __webpack_public_path__ + "static/media/52_B.f17ce2b9.png";